import type { ImpactLevel } from '@vizit/atoms';
import type { ImpactBolts } from '@vizit/molecules';

/**
 * Maps the BE per-category bolts contract (1–4) to the ImpactBolt molecule's
 * ImpactLevel scale. Kept here so it can be unit-tested without rendering React.
 */
const BOLTS_TO_LEVEL: Record<ImpactBolts, ImpactLevel> = {
  1: 'very-low',
  2: 'low',
  3: 'medium',
  4: 'high',
};

/**
 * Resolves a metric cell's ImpactLevel from the BE bolts value, falling back
 * to the cell-specific hardcoded level when bolts is missing or out of spec.
 *
 * The `?? fallback` is defense-in-depth: the API-layer `isValidBolts` guard
 * already filters wire data, but a mock, cast, or future caller could still
 * slip a value like 0 or 5 past TypeScript's narrowing. Without it,
 * BOLTS_TO_LEVEL[bolts] would return undefined and crash ImpactBolt downstream.
 */
const resolveLevel = (bolts: ImpactBolts | undefined, fallback: ImpactLevel): ImpactLevel =>
  bolts !== undefined ? (BOLTS_TO_LEVEL[bolts] ?? fallback) : fallback;

export { BOLTS_TO_LEVEL, resolveLevel };
